import {
    REPORT_TARGET_AGREEMENTS_VALUE,
    REPORT_TARGET_MATERIAL_SUMMARY_VALUE,
} from '../taskpane.constants';
import { executeAgreementsReportingTargetFetch } from './handlers/agreements-reporting-target.fetch-handler';
import { executeMaterialSummaryReportingTargetFetch } from './handlers/material-summary-reporting-target.fetch-handler';
import type { ReportFetchHandler } from './report-fetch.types';

function buildDefaultReportFetchHandlerMap(): ReadonlyMap<string, ReportFetchHandler> {
    return new Map<string, ReportFetchHandler>([
        [REPORT_TARGET_AGREEMENTS_VALUE, executeAgreementsReportingTargetFetch],
        [REPORT_TARGET_MATERIAL_SUMMARY_VALUE, executeMaterialSummaryReportingTargetFetch],
    ]);
}

const defaultReportFetchHandlerMap = buildDefaultReportFetchHandlerMap();

/**
 * Resolves the fetch implementation for a reporting target. Unknown targets return `undefined`.
 */
export function getReportFetchHandler(
    targetId: string,
    overrides?: ReadonlyMap<string, ReportFetchHandler>
): ReportFetchHandler | undefined {
    const fromOverrides = overrides?.get(targetId);
    if (fromOverrides) {
        return fromOverrides;
    }
    return defaultReportFetchHandlerMap.get(targetId);
}
